import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './ScannerDetailLayout.resolver';
import ScannerDetailLayout from './ScannerDetailLayout';

export default async(resolver, { context: RootStoreContext })(
  ScannerDetailLayout
);
